import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Typography,
    Card,
    Select,
    Form,
    DatePicker,
    Col,
    Divider,
    Button,
    Spin,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { LeftOutlined } from '@ant-design/icons';


//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from '../../../components/layouts/MainLayout';
import TopContent from '../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from '../security.config';
import CustomButton from '../../../components/custom/CustomButton';
import dayjs from "dayjs";

const { Text, Title } = Typography

function DetailEmployee(props) {

    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [employeeDetail, setEmployeeDetail] = useState({});


    useEffect(() => {
        getDetalById();
    }, []);

    const getDetalById = () => {
        const url = `${apiConfig.Staff}/${state.id}`;
        const params = {
            status: "all",
        };
        let body = {
            session,
            params,
        };
        setIsLoading(true)
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            } else {
                const objDetail = res;
                setEmployeeDetail(objDetail);
                useForm.setFieldsValue({
                    officeName: objDetail?.officeName,
                    firstname: objDetail?.firstname,
                    lastname: objDetail?.lastname,
                    isLoanOfficer: objDetail?.isLoanOfficer ? "Yes" : "No",
                    mobileNo: objDetail?.mobileNo,
                    active: objDetail?.isActive ? "Yes" : "No",
                    joiningDate: objDetail?.joiningDate ? BOM.FormatArrayDate(objDetail?.joiningDate) : "-",
                })
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };
    function onCancel() {
        navigate("/sms0200", { state: state });
    };

    return (

        <MainLayout isEnableRightSidebar={true} >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.detailEmployee}
                pageItems={staticConfig.detailEmployeesBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}

                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form
                        form={useForm}
                        layout="vertical"
                    >
                        <Row>
                            <Divider orientation="left" orientationMargin="0">
                                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                    {employeeDetail?.displayName}
                                </Title>
                            </Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.branch}
                                    name="officeName"
                                >
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.firstName}
                                    name="firstname"
                                >
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.lastName}
                                    name="lastname"
                                >
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.isLoanOfficer}
                                    name="isLoanOfficer"
                                >
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.mobileNumberforSMS}
                                    name="mobileNo"
                                >
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.active}
                                    name="active"
                                >
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.joinedOn}
                                    name="joiningDate"
                                >
                                    <Input
                                        disabled
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                </Card>
            </Spin>

        </MainLayout>
    );
};
export default DetailEmployee;

